import { useStripe, useElements, CardElement, Elements } from '@stripe/react-stripe-js';
import React, { useState } from 'react';
import FormInput from './Input';
import { loadStripe } from '@stripe/stripe-js';
import Button from './Button';

interface CreditCardFormProps {
    updateCreditCard: boolean;
    setLoading: (loading: boolean) => void;
    captureToken: (id: string) => Promise<void>;
    handleRedeemFailed: (error: string) => void;
}

const UnwrappedCreditCardForm = (props: CreditCardFormProps) => {
    const stripe = useStripe();
    const elements = useElements();
    const [cardHolderName, setCardHolderName] = useState('');

    const saveCreditCard = async () => {
        if (!stripe || !elements) {
            return;
        }
        let cardElement = elements.getElement(CardElement);
        if (!cardElement) {
            return;
        }
        const { token, error } = await stripe.createToken(cardElement, { name: cardHolderName });
        if (error || !token) {
            props.handleRedeemFailed((error && error.message) || 'Failed to connect credit card');
            return;
        }

        await props.captureToken(token.id);
    };

    const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        props.setLoading(true);

        await saveCreditCard();

        props.setLoading(false);
    };

    return (
        <div>
            <p className=" pb-2">Credit card validation - There is no charge for the tour.</p>
            <form onSubmit={handleSubmit} className="credit-card-input">
                <FormInput
                    inputProps={{
                        id: 'card-holder-name',
                        name: 'cardHolderName',
                        type: 'text',
                        placeholder: 'Jane Doe',
                        value: cardHolderName,
                        required: true
                    }}
                    labelProps={{
                        labelText: 'Credit Card Holder Name',
                        invalidText: 'Please enter the card holder name'
                    }}
                    onChange={(_name, value) => setCardHolderName(value.toString())}
                />
                <div className="form-group">
                    <label className="font-weight-bold">Credit Card Details</label>
                    <CardElement />
                </div>

                <div className="navigation-buttons">
                    <Button type="submit" disabled={!stripe} text="Next" />
                </div>
            </form>
        </div>
    );
};

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_API_KEY!);

const CreditCardForm = (props: CreditCardFormProps) => (
    <Elements stripe={stripePromise}>
        <UnwrappedCreditCardForm {...props} />
    </Elements>
);

export default CreditCardForm;



// WEBPACK FOOTER //
// ./src/components/common/form/CreditCardForm.tsx